// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as MaintenanceIndexRouteImport } from './routes/maintenance/index'
import { Route as PdfIdRouteImport } from './routes/pdf/$id'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppDashboardsRouteRouteImport } from './routes/_app/_dashboards/route'
import { Route as AppSanitaetshaeuserIndexRouteImport } from './routes/_app/sanitaetshaeuser/index'
import { Route as AppPraxenIndexRouteImport } from './routes/_app/praxen/index'
import { Route as AppPflegeheimeIndexRouteImport } from './routes/_app/pflegeheime/index'
import { Route as AppPflegediensteIndexRouteImport } from './routes/_app/pflegedienste/index'
import { Route as AppPatientenIndexRouteImport } from './routes/_app/patienten/index'
import { Route as AppMitarbeiterIndexRouteImport } from './routes/_app/mitarbeiter/index'
import { Route as AppMedizintechnikIndexRouteImport } from './routes/_app/medizintechnik/index'
import { Route as AppKostentragerIndexRouteImport } from './routes/_app/kostentrager/index'
import { Route as AppKlinikenIndexRouteImport } from './routes/_app/kliniken/index'
import { Route as AppHospizeIndexRouteImport } from './routes/_app/hospize/index'
import { Route as AppArtikelIndexRouteImport } from './routes/_app/artikel/index'
import { Route as AppApothekenIndexRouteImport } from './routes/_app/apotheken/index'
import { Route as AppAdteamIndexRouteImport } from './routes/_app/adteam/index'
import { Route as AppSanitaetshaeuserIdRouteImport } from './routes/_app/sanitaetshaeuser/$id'
import { Route as AppPraxenIdRouteImport } from './routes/_app/praxen/$id'
import { Route as AppPflegeheimeIdRouteImport } from './routes/_app/pflegeheime/$id'
import { Route as AppPflegediensteIdRouteImport } from './routes/_app/pflegedienste/$id'
import { Route as AppMitarbeiterIdRouteImport } from './routes/_app/mitarbeiter/$id'
import { Route as AppMedizintechnikIdRouteImport } from './routes/_app/medizintechnik/$id'
import { Route as AppKostentragerIdRouteImport } from './routes/_app/kostentrager/$id'
import { Route as AppKlinikenIdRouteImport } from './routes/_app/kliniken/$id'
import { Route as AppHospizeIdRouteImport } from './routes/_app/hospize/$id'
import { Route as AppGotoIdRouteImport } from './routes/_app/goto.$id'
import { Route as AppArtikelIdRouteImport } from './routes/_app/artikel/$id'
import { Route as AppApothekenIdRouteImport } from './routes/_app/apotheken/$id'
import { Route as AppAdteamIdRouteImport } from './routes/_app/adteam/$id'
import { Route as AppPatientenIdRouteRouteImport } from './routes/_app/patienten/$id/route'
import { Route as AppDashboardsSignedRouteImport } from './routes/_app/_dashboards/signed'
import { Route as AppDashboardsRegisteredPatientsRouteImport } from './routes/_app/_dashboards/registered-patients'
import { Route as AppDashboardsProgressReportsRouteImport } from './routes/_app/_dashboards/progress-reports'
import { Route as AppDashboardsOrdersStockRouteImport } from './routes/_app/_dashboards/orders-stock'
import { Route as AppDashboardsOrdersRouteImport } from './routes/_app/_dashboards/orders'
import { Route as AppDashboardsNotificationsRouteImport } from './routes/_app/_dashboards/notifications'
import { Route as AppDashboardsMyPatientsRouteImport } from './routes/_app/_dashboards/my-patients'
import { Route as AppDashboardsMissingDataRouteImport } from './routes/_app/_dashboards/missing-data'
import { Route as AppDashboardsMasterDataSheetsRouteImport } from './routes/_app/_dashboards/master-data-sheets'
import { Route as AppDashboardsBiaMeasurementsRouteImport } from './routes/_app/_dashboards/bia-measurements'
import { Route as AppSanitaetshaeuserIdIndexRouteImport } from './routes/_app/sanitaetshaeuser/$id.index'
import { Route as AppSanitaetshaeuserIdContactPersonsRouteImport } from './routes/_app/sanitaetshaeuser/$id.contact-persons'
import { Route as AppPraxenIdIndexRouteImport } from './routes/_app/praxen/$id.index'
import { Route as AppPraxenIdContactPersonsRouteImport } from './routes/_app/praxen/$id.contact-persons'
import { Route as AppPflegeheimeIdIndexRouteImport } from './routes/_app/pflegeheime/$id.index'
import { Route as AppPflegeheimeIdContactPersonsRouteImport } from './routes/_app/pflegeheime/$id.contact-persons'
import { Route as AppPflegediensteIdIndexRouteImport } from './routes/_app/pflegedienste/$id.index'
import { Route as AppPflegediensteIdContactPersonsRouteImport } from './routes/_app/pflegedienste/$id.contact-persons'
import { Route as AppMitarbeiterIdIndexRouteImport } from './routes/_app/mitarbeiter/$id.index'
import { Route as AppMedizintechnikIdIndexRouteImport } from './routes/_app/medizintechnik/$id.index'
import { Route as AppMedizintechnikIdContactPersonsRouteImport } from './routes/_app/medizintechnik/$id.contact-persons'
import { Route as AppKostentragerIdIndexRouteImport } from './routes/_app/kostentrager/$id.index'
import { Route as AppKostentragerIdIkNumbersRouteImport } from './routes/_app/kostentrager/$id.ik-numbers'
import { Route as AppKostentragerIdContactPersonsRouteImport } from './routes/_app/kostentrager/$id.contact-persons'
import { Route as AppKlinikenIdIndexRouteImport } from './routes/_app/kliniken/$id.index'
import { Route as AppKlinikenIdStationsRouteImport } from './routes/_app/kliniken/$id.stations'
import { Route as AppKlinikenIdContactPersonsRouteImport } from './routes/_app/kliniken/$id.contact-persons'
import { Route as AppHospizeIdIndexRouteImport } from './routes/_app/hospize/$id.index'
import { Route as AppHospizeIdContactPersonsRouteImport } from './routes/_app/hospize/$id.contact-persons'
import { Route as AppArtikelIdIndexRouteImport } from './routes/_app/artikel/$id.index'
import { Route as AppArtikelIdRelationsRouteImport } from './routes/_app/artikel/$id.relations'
import { Route as AppApothekenIdIndexRouteImport } from './routes/_app/apotheken/$id.index'
import { Route as AppApothekenIdContactPersonsRouteImport } from './routes/_app/apotheken/$id.contact-persons'
import { Route as AppAdteamIdIndexRouteImport } from './routes/_app/adteam/$id.index'
import { Route as AppPatientenIdEditRouteRouteImport } from './routes/_app/patienten/$id/_edit/route'
import { Route as AppPatientenIdOverviewIndexRouteImport } from './routes/_app/patienten/$id/_overview/index'
import { Route as AppPatientenIdEditZustandigkeitRouteImport } from './routes/_app/patienten/$id/_edit/zustandigkeit'
import { Route as AppPatientenIdEditStammdatenRouteImport } from './routes/_app/patienten/$id/_edit/stammdaten'
import { Route as AppPatientenIdEditAnamneseRouteImport } from './routes/_app/patienten/$id/_edit/anamnese'
import { Route as AppPatientenIdEditTherapyTherapienRouteImport } from './routes/_app/patienten/$id/_edit/_therapy/therapien'
import { Route as AppPatientenIdEditResidencesAufenthaltsorteRouteImport } from './routes/_app/patienten/$id/_edit/_residences/aufenthaltsorte'
import { Route as AppPatientenIdEditPharmacyApothekenRouteImport } from './routes/_app/patienten/$id/_edit/_pharmacy/apotheken'
import { Route as AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerRouteImport } from './routes/_app/patienten/$id/_edit/_medicalTechnology/medizintechnikversorger'
import { Route as AppPatientenIdEditDocumentsVerlaufsdokumentationRouteImport } from './routes/_app/patienten/$id/_edit/_documents/verlaufsdokumentation'
import { Route as AppPatientenIdEditDocumentsUnterschriftsdokumenteRouteImport } from './routes/_app/patienten/$id/_edit/_documents/unterschriftsdokumente'
import { Route as AppPatientenIdEditDocumentsStammblattRouteImport } from './routes/_app/patienten/$id/_edit/_documents/stammblatt'
import { Route as AppPatientenIdEditDocumentsBiaMessungRouteImport } from './routes/_app/patienten/$id/_edit/_documents/bia-messung'
import { Route as AppPatientenIdEditDocumentsBedarfsermittlungenRouteImport } from './routes/_app/patienten/$id/_edit/_documents/bedarfsermittlungen'
import { Route as AppPatientenIdEditDoctorPraxenRouteImport } from './routes/_app/patienten/$id/_edit/_doctor/praxen'
import { Route as AppPatientenIdEditCostCarrierKostentraegerRouteImport } from './routes/_app/patienten/$id/_edit/_costCarrier/kostentraeger'
import { Route as AppPatientenIdEditCooperationPartnerKooperationspartnerRouteImport } from './routes/_app/patienten/$id/_edit/_cooperationPartner/kooperationspartner'
import { Route as AppPatientenIdEditClinicKlinikenRouteImport } from './routes/_app/patienten/$id/_edit/_clinic/kliniken'
import { Route as AppPatientenIdEditCareServicePflegediensteRouteImport } from './routes/_app/patienten/$id/_edit/_careService/pflegedienste'
import { Route as AppPatientenIdEditApplicantAnmelderRouteImport } from './routes/_app/patienten/$id/_edit/_applicant/anmelder'
import { Route as AppPatientenIdEditZustandigkeitIndexRouteImport } from './routes/_app/patienten/$id/_edit/zustandigkeit/index'
import { Route as AppPatientenIdEditZustandigkeitVersorgungsmanagerRouteImport } from './routes/_app/patienten/$id/_edit/zustandigkeit/versorgungsmanager'
import { Route as AppPatientenIdEditZustandigkeitAdTeamRouteImport } from './routes/_app/patienten/$id/_edit/zustandigkeit/ad-team'
import { Route as AppPatientenIdEditStammdatenIndexRouteImport } from './routes/_app/patienten/$id/_edit/stammdaten/index'
import { Route as AppPatientenIdEditStammdatenRechnungsadressenRouteImport } from './routes/_app/patienten/$id/_edit/stammdaten/rechnungsadressen'
import { Route as AppPatientenIdEditStammdatenLieferadressenRouteImport } from './routes/_app/patienten/$id/_edit/stammdaten/lieferadressen'
import { Route as AppPatientenIdEditStammdatenAngehoerigeRouteImport } from './routes/_app/patienten/$id/_edit/stammdaten/angehoerige'
import { Route as AppPatientenIdEditAnamneseIndexRouteImport } from './routes/_app/patienten/$id/_edit/anamnese/index'
import { Route as AppPatientenIdEditAnamneseZugangRouteImport } from './routes/_app/patienten/$id/_edit/anamnese/zugang'
import { Route as AppPatientenIdEditAnamnesePflegegradRouteImport } from './routes/_app/patienten/$id/_edit/anamnese/pflegegrad'
import { Route as AppPatientenIdEditAnamneseMobilitaetRouteImport } from './routes/_app/patienten/$id/_edit/anamnese/mobilitaet'
import { Route as AppPatientenIdEditAnamneseKoerpergroesseRouteImport } from './routes/_app/patienten/$id/_edit/anamnese/koerpergroesse'
import { Route as AppPatientenIdEditAnamneseGewichtRouteImport } from './routes/_app/patienten/$id/_edit/anamnese/gewicht'
import { Route as AppPatientenIdEditAnamneseDiagnoseRouteImport } from './routes/_app/patienten/$id/_edit/anamnese/diagnose'
import { Route as AppPatientenIdEditDocumentsFormsVerlaufsdokumentationRouteRouteImport } from './routes/_app/patienten/$id/_edit/_documents/_forms/verlaufsdokumentation/route'
import { Route as AppPatientenIdEditDocumentsFormsStammblattRouteRouteImport } from './routes/_app/patienten/$id/_edit/_documents/_forms/stammblatt/route'
import { Route as AppPatientenIdEditDocumentsFormsBiaMessungRouteRouteImport } from './routes/_app/patienten/$id/_edit/_documents/_forms/bia-messung/route'
import { Route as AppPatientenIdEditDocumentsFormsBedarfsermittlungRouteRouteImport } from './routes/_app/patienten/$id/_edit/_documents/_forms/bedarfsermittlung/route'
import { Route as AppPatientenIdEditDocumentsFormsUnterschriftdokumenteRouteRouteImport } from './routes/_app/patienten/$id/_edit/_documents/_forms/_unterschriftdokumente/route'
import { Route as AppPatientenIdEditTherapyTherapienIndexRouteImport } from './routes/_app/patienten/$id/_edit/_therapy/therapien.index'
import { Route as AppPatientenIdEditTherapyTherapienRelationRouteImport } from './routes/_app/patienten/$id/_edit/_therapy/therapien.$relation'
import { Route as AppPatientenIdEditResidencesAufenthaltsorteIndexRouteImport } from './routes/_app/patienten/$id/_edit/_residences/aufenthaltsorte.index'
import { Route as AppPatientenIdEditResidencesAufenthaltsorteRelationRouteImport } from './routes/_app/patienten/$id/_edit/_residences/aufenthaltsorte.$relation'
import { Route as AppPatientenIdEditPharmacyApothekenIndexRouteImport } from './routes/_app/patienten/$id/_edit/_pharmacy/apotheken.index'
import { Route as AppPatientenIdEditPharmacyApothekenRelationRouteImport } from './routes/_app/patienten/$id/_edit/_pharmacy/apotheken.$relation'
import { Route as AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerIndexRouteImport } from './routes/_app/patienten/$id/_edit/_medicalTechnology/medizintechnikversorger.index'
import { Route as AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerRelationRouteImport } from './routes/_app/patienten/$id/_edit/_medicalTechnology/medizintechnikversorger.$relation'
import { Route as AppPatientenIdEditDocumentsUnterschriftsdokumenteIndexRouteImport } from './routes/_app/patienten/$id/_edit/_documents/unterschriftsdokumente.index'
import { Route as AppPatientenIdEditDocumentsUnterschriftsdokumenteVersorgungsauftragRouteImport } from './routes/_app/patienten/$id/_edit/_documents/unterschriftsdokumente.versorgungsauftrag'
import { Route as AppPatientenIdEditDocumentsUnterschriftsdokumentePatienteninformationenRouteImport } from './routes/_app/patienten/$id/_edit/_documents/unterschriftsdokumente.patienteninformationen'
import { Route as AppPatientenIdEditDocumentsUnterschriftsdokumenteEinwilligungSchweigepflichtRouteImport } from './routes/_app/patienten/$id/_edit/_documents/unterschriftsdokumente.einwilligung-schweigepflicht'
import { Route as AppPatientenIdEditDocumentsBedarfsermittlungenIndexRouteImport } from './routes/_app/patienten/$id/_edit/_documents/bedarfsermittlungen.index'
import { Route as AppPatientenIdEditDocumentsBedarfsermittlungenTherapyRouteImport } from './routes/_app/patienten/$id/_edit/_documents/bedarfsermittlungen.$therapy'
import { Route as AppPatientenIdEditDoctorPraxenIndexRouteImport } from './routes/_app/patienten/$id/_edit/_doctor/praxen.index'
import { Route as AppPatientenIdEditDoctorPraxenRelationRouteImport } from './routes/_app/patienten/$id/_edit/_doctor/praxen.$relation'
import { Route as AppPatientenIdEditCostCarrierKostentraegerIndexRouteImport } from './routes/_app/patienten/$id/_edit/_costCarrier/kostentraeger.index'
import { Route as AppPatientenIdEditCostCarrierKostentraegerRelationRouteImport } from './routes/_app/patienten/$id/_edit/_costCarrier/kostentraeger.$relation'
import { Route as AppPatientenIdEditCooperationPartnerKooperationspartnerIndexRouteImport } from './routes/_app/patienten/$id/_edit/_cooperationPartner/kooperationspartner.index'
import { Route as AppPatientenIdEditCooperationPartnerKooperationspartnerRelationRouteImport } from './routes/_app/patienten/$id/_edit/_cooperationPartner/kooperationspartner.$relation'
import { Route as AppPatientenIdEditClinicKlinikenIndexRouteImport } from './routes/_app/patienten/$id/_edit/_clinic/kliniken.index'
import { Route as AppPatientenIdEditClinicKlinikenRelationRouteImport } from './routes/_app/patienten/$id/_edit/_clinic/kliniken.$relation'
import { Route as AppPatientenIdEditCareServicePflegediensteIndexRouteImport } from './routes/_app/patienten/$id/_edit/_careService/pflegedienste.index'
import { Route as AppPatientenIdEditCareServicePflegediensteRelationRouteImport } from './routes/_app/patienten/$id/_edit/_careService/pflegedienste.$relation'
import { Route as AppPatientenIdEditApplicantAnmelderIndexRouteImport } from './routes/_app/patienten/$id/_edit/_applicant/anmelder.index'
import { Route as AppPatientenIdEditApplicantAnmelderRelationRouteImport } from './routes/_app/patienten/$id/_edit/_applicant/anmelder.$relation'
import { Route as AppPatientenIdEditDocumentsFormsStammblattNewRouteImport } from './routes/_app/patienten/$id/_edit/_documents/_forms/stammblatt/new'
import { Route as AppPatientenIdEditDocumentsFormsBedarfsermittlungNewRouteImport } from './routes/_app/patienten/$id/_edit/_documents/_forms/bedarfsermittlung/new'
import { Route as AppPatientenIdEditDocumentsFormsBedarfsermittlungFormRouteImport } from './routes/_app/patienten/$id/_edit/_documents/_forms/bedarfsermittlung/$form'
import { Route as AppPatientenIdEditDocumentsFormsVerlaufsdokumentationFormIndexRouteImport } from './routes/_app/patienten/$id/_edit/_documents/_forms/verlaufsdokumentation/$form/index'
import { Route as AppPatientenIdEditDocumentsFormsStammblattFormIndexRouteImport } from './routes/_app/patienten/$id/_edit/_documents/_forms/stammblatt/$form/index'
import { Route as AppPatientenIdEditDocumentsFormsBiaMessungFormIndexRouteImport } from './routes/_app/patienten/$id/_edit/_documents/_forms/bia-messung/$form/index'
import { Route as AppPatientenIdEditDocumentsFormsBedarfsermittlungFormIndexRouteImport } from './routes/_app/patienten/$id/_edit/_documents/_forms/bedarfsermittlung/$form.index'
import { Route as AppPatientenIdEditDocumentsFormsBedarfsermittlungFormArticlesRouteImport } from './routes/_app/patienten/$id/_edit/_documents/_forms/bedarfsermittlung/$form.articles'
import { Route as AppPatientenIdEditDocumentsFormsUnterschriftdokumenteVersorgungsauftragFormIndexRouteImport } from './routes/_app/patienten/$id/_edit/_documents/_forms/_unterschriftdokumente/versorgungsauftrag/$form/index'
import { Route as AppPatientenIdEditDocumentsFormsUnterschriftdokumentePatientenInformationFormIndexRouteImport } from './routes/_app/patienten/$id/_edit/_documents/_forms/_unterschriftdokumente/patienten-information/$form/index'
import { Route as AppPatientenIdEditDocumentsFormsUnterschriftdokumenteEinwilligungSchweigepflichtFormIndexRouteImport } from './routes/_app/patienten/$id/_edit/_documents/_forms/_unterschriftdokumente/einwilligung-schweigepflicht/$form/index'

const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const MaintenanceIndexRoute = MaintenanceIndexRouteImport.update({
            id: '/maintenance/',path: '/maintenance/',getParentRoute: () => rootRouteImport
          })
const PdfIdRoute = PdfIdRouteImport.update({
            id: '/pdf/$id',path: '/pdf/$id',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppDashboardsRouteRoute = AppDashboardsRouteRouteImport.update({
            id: '/_dashboards',getParentRoute: () => AppRoute
          })
const AppSanitaetshaeuserIndexRoute = AppSanitaetshaeuserIndexRouteImport.update({
            id: '/sanitaetshaeuser/',path: '/sanitaetshaeuser/',getParentRoute: () => AppRoute
          })
const AppPraxenIndexRoute = AppPraxenIndexRouteImport.update({
            id: '/praxen/',path: '/praxen/',getParentRoute: () => AppRoute
          })
const AppPflegeheimeIndexRoute = AppPflegeheimeIndexRouteImport.update({
            id: '/pflegeheime/',path: '/pflegeheime/',getParentRoute: () => AppRoute
          })
const AppPflegediensteIndexRoute = AppPflegediensteIndexRouteImport.update({
            id: '/pflegedienste/',path: '/pflegedienste/',getParentRoute: () => AppRoute
          })
const AppPatientenIndexRoute = AppPatientenIndexRouteImport.update({
            id: '/patienten/',path: '/patienten/',getParentRoute: () => AppRoute
          })
const AppMitarbeiterIndexRoute = AppMitarbeiterIndexRouteImport.update({
            id: '/mitarbeiter/',path: '/mitarbeiter/',getParentRoute: () => AppRoute
          })
const AppMedizintechnikIndexRoute = AppMedizintechnikIndexRouteImport.update({
            id: '/medizintechnik/',path: '/medizintechnik/',getParentRoute: () => AppRoute
          })
const AppKostentragerIndexRoute = AppKostentragerIndexRouteImport.update({
            id: '/kostentrager/',path: '/kostentrager/',getParentRoute: () => AppRoute
          })
const AppKlinikenIndexRoute = AppKlinikenIndexRouteImport.update({
            id: '/kliniken/',path: '/kliniken/',getParentRoute: () => AppRoute
          })
const AppHospizeIndexRoute = AppHospizeIndexRouteImport.update({
            id: '/hospize/',path: '/hospize/',getParentRoute: () => AppRoute
          })
const AppArtikelIndexRoute = AppArtikelIndexRouteImport.update({
            id: '/artikel/',path: '/artikel/',getParentRoute: () => AppRoute
          })
const AppApothekenIndexRoute = AppApothekenIndexRouteImport.update({
            id: '/apotheken/',path: '/apotheken/',getParentRoute: () => AppRoute
          })
const AppAdteamIndexRoute = AppAdteamIndexRouteImport.update({
            id: '/adteam/',path: '/adteam/',getParentRoute: () => AppRoute
          })
const AppSanitaetshaeuserIdRoute = AppSanitaetshaeuserIdRouteImport.update({
            id: '/sanitaetshaeuser/$id',path: '/sanitaetshaeuser/$id',getParentRoute: () => AppRoute
          })
const AppPraxenIdRoute = AppPraxenIdRouteImport.update({
            id: '/praxen/$id',path: '/praxen/$id',getParentRoute: () => AppRoute
          })
const AppPflegeheimeIdRoute = AppPflegeheimeIdRouteImport.update({
            id: '/pflegeheime/$id',path: '/pflegeheime/$id',getParentRoute: () => AppRoute
          })
const AppPflegediensteIdRoute = AppPflegediensteIdRouteImport.update({
            id: '/pflegedienste/$id',path: '/pflegedienste/$id',getParentRoute: () => AppRoute
          })
const AppMitarbeiterIdRoute = AppMitarbeiterIdRouteImport.update({
            id: '/mitarbeiter/$id',path: '/mitarbeiter/$id',getParentRoute: () => AppRoute
          })
const AppMedizintechnikIdRoute = AppMedizintechnikIdRouteImport.update({
            id: '/medizintechnik/$id',path: '/medizintechnik/$id',getParentRoute: () => AppRoute
          })
const AppKostentragerIdRoute = AppKostentragerIdRouteImport.update({
            id: '/kostentrager/$id',path: '/kostentrager/$id',getParentRoute: () => AppRoute
          })
const AppKlinikenIdRoute = AppKlinikenIdRouteImport.update({
            id: '/kliniken/$id',path: '/kliniken/$id',getParentRoute: () => AppRoute
          })
const AppHospizeIdRoute = AppHospizeIdRouteImport.update({
            id: '/hospize/$id',path: '/hospize/$id',getParentRoute: () => AppRoute
          })
const AppGotoIdRoute = AppGotoIdRouteImport.update({
            id: '/goto/$id',path: '/goto/$id',getParentRoute: () => AppRoute
          })
const AppArtikelIdRoute = AppArtikelIdRouteImport.update({
            id: '/artikel/$id',path: '/artikel/$id',getParentRoute: () => AppRoute
          })
const AppApothekenIdRoute = AppApothekenIdRouteImport.update({
            id: '/apotheken/$id',path: '/apotheken/$id',getParentRoute: () => AppRoute
          })
const AppAdteamIdRoute = AppAdteamIdRouteImport.update({
            id: '/adteam/$id',path: '/adteam/$id',getParentRoute: () => AppRoute
          })
const AppPatientenIdRouteRoute = AppPatientenIdRouteRouteImport.update({
            id: '/patienten/$id',path: '/patienten/$id',getParentRoute: () => AppRoute
          })
const AppDashboardsSignedRoute = AppDashboardsSignedRouteImport.update({
            id: '/signed',path: '/signed',getParentRoute: () => AppDashboardsRouteRoute
          })
const AppDashboardsRegisteredPatientsRoute = AppDashboardsRegisteredPatientsRouteImport.update({
            id: '/registered-patients',path: '/registered-patients',getParentRoute: () => AppDashboardsRouteRoute
          })
const AppDashboardsProgressReportsRoute = AppDashboardsProgressReportsRouteImport.update({
            id: '/progress-reports',path: '/progress-reports',getParentRoute: () => AppDashboardsRouteRoute
          })
const AppDashboardsOrdersStockRoute = AppDashboardsOrdersStockRouteImport.update({
            id: '/orders-stock',path: '/orders-stock',getParentRoute: () => AppDashboardsRouteRoute
          })
const AppDashboardsOrdersRoute = AppDashboardsOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AppDashboardsRouteRoute
          })
const AppDashboardsNotificationsRoute = AppDashboardsNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AppDashboardsRouteRoute
          })
const AppDashboardsMyPatientsRoute = AppDashboardsMyPatientsRouteImport.update({
            id: '/my-patients',path: '/my-patients',getParentRoute: () => AppDashboardsRouteRoute
          })
const AppDashboardsMissingDataRoute = AppDashboardsMissingDataRouteImport.update({
            id: '/missing-data',path: '/missing-data',getParentRoute: () => AppDashboardsRouteRoute
          })
const AppDashboardsMasterDataSheetsRoute = AppDashboardsMasterDataSheetsRouteImport.update({
            id: '/master-data-sheets',path: '/master-data-sheets',getParentRoute: () => AppDashboardsRouteRoute
          })
const AppDashboardsBiaMeasurementsRoute = AppDashboardsBiaMeasurementsRouteImport.update({
            id: '/bia-measurements',path: '/bia-measurements',getParentRoute: () => AppDashboardsRouteRoute
          })
const AppSanitaetshaeuserIdIndexRoute = AppSanitaetshaeuserIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppSanitaetshaeuserIdRoute
          })
const AppSanitaetshaeuserIdContactPersonsRoute = AppSanitaetshaeuserIdContactPersonsRouteImport.update({
            id: '/contact-persons',path: '/contact-persons',getParentRoute: () => AppSanitaetshaeuserIdRoute
          })
const AppPraxenIdIndexRoute = AppPraxenIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPraxenIdRoute
          })
const AppPraxenIdContactPersonsRoute = AppPraxenIdContactPersonsRouteImport.update({
            id: '/contact-persons',path: '/contact-persons',getParentRoute: () => AppPraxenIdRoute
          })
const AppPflegeheimeIdIndexRoute = AppPflegeheimeIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPflegeheimeIdRoute
          })
const AppPflegeheimeIdContactPersonsRoute = AppPflegeheimeIdContactPersonsRouteImport.update({
            id: '/contact-persons',path: '/contact-persons',getParentRoute: () => AppPflegeheimeIdRoute
          })
const AppPflegediensteIdIndexRoute = AppPflegediensteIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPflegediensteIdRoute
          })
const AppPflegediensteIdContactPersonsRoute = AppPflegediensteIdContactPersonsRouteImport.update({
            id: '/contact-persons',path: '/contact-persons',getParentRoute: () => AppPflegediensteIdRoute
          })
const AppMitarbeiterIdIndexRoute = AppMitarbeiterIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppMitarbeiterIdRoute
          })
const AppMedizintechnikIdIndexRoute = AppMedizintechnikIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppMedizintechnikIdRoute
          })
const AppMedizintechnikIdContactPersonsRoute = AppMedizintechnikIdContactPersonsRouteImport.update({
            id: '/contact-persons',path: '/contact-persons',getParentRoute: () => AppMedizintechnikIdRoute
          })
const AppKostentragerIdIndexRoute = AppKostentragerIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppKostentragerIdRoute
          })
const AppKostentragerIdIkNumbersRoute = AppKostentragerIdIkNumbersRouteImport.update({
            id: '/ik-numbers',path: '/ik-numbers',getParentRoute: () => AppKostentragerIdRoute
          })
const AppKostentragerIdContactPersonsRoute = AppKostentragerIdContactPersonsRouteImport.update({
            id: '/contact-persons',path: '/contact-persons',getParentRoute: () => AppKostentragerIdRoute
          })
const AppKlinikenIdIndexRoute = AppKlinikenIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppKlinikenIdRoute
          })
const AppKlinikenIdStationsRoute = AppKlinikenIdStationsRouteImport.update({
            id: '/stations',path: '/stations',getParentRoute: () => AppKlinikenIdRoute
          })
const AppKlinikenIdContactPersonsRoute = AppKlinikenIdContactPersonsRouteImport.update({
            id: '/contact-persons',path: '/contact-persons',getParentRoute: () => AppKlinikenIdRoute
          })
const AppHospizeIdIndexRoute = AppHospizeIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppHospizeIdRoute
          })
const AppHospizeIdContactPersonsRoute = AppHospizeIdContactPersonsRouteImport.update({
            id: '/contact-persons',path: '/contact-persons',getParentRoute: () => AppHospizeIdRoute
          })
const AppArtikelIdIndexRoute = AppArtikelIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppArtikelIdRoute
          })
const AppArtikelIdRelationsRoute = AppArtikelIdRelationsRouteImport.update({
            id: '/relations',path: '/relations',getParentRoute: () => AppArtikelIdRoute
          })
const AppApothekenIdIndexRoute = AppApothekenIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppApothekenIdRoute
          })
const AppApothekenIdContactPersonsRoute = AppApothekenIdContactPersonsRouteImport.update({
            id: '/contact-persons',path: '/contact-persons',getParentRoute: () => AppApothekenIdRoute
          })
const AppAdteamIdIndexRoute = AppAdteamIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAdteamIdRoute
          })
const AppPatientenIdEditRouteRoute = AppPatientenIdEditRouteRouteImport.update({
            id: '/_edit',getParentRoute: () => AppPatientenIdRouteRoute
          })
const AppPatientenIdOverviewIndexRoute = AppPatientenIdOverviewIndexRouteImport.update({
            id: '/_overview/',path: '/',getParentRoute: () => AppPatientenIdRouteRoute
          })
const AppPatientenIdEditZustandigkeitRoute = AppPatientenIdEditZustandigkeitRouteImport.update({
            id: '/zustandigkeit',path: '/zustandigkeit',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditStammdatenRoute = AppPatientenIdEditStammdatenRouteImport.update({
            id: '/stammdaten',path: '/stammdaten',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditAnamneseRoute = AppPatientenIdEditAnamneseRouteImport.update({
            id: '/anamnese',path: '/anamnese',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditTherapyTherapienRoute = AppPatientenIdEditTherapyTherapienRouteImport.update({
            id: '/_therapy/therapien',path: '/therapien',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditResidencesAufenthaltsorteRoute = AppPatientenIdEditResidencesAufenthaltsorteRouteImport.update({
            id: '/_residences/aufenthaltsorte',path: '/aufenthaltsorte',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditPharmacyApothekenRoute = AppPatientenIdEditPharmacyApothekenRouteImport.update({
            id: '/_pharmacy/apotheken',path: '/apotheken',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerRoute = AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerRouteImport.update({
            id: '/_medicalTechnology/medizintechnikversorger',path: '/medizintechnikversorger',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditDocumentsVerlaufsdokumentationRoute = AppPatientenIdEditDocumentsVerlaufsdokumentationRouteImport.update({
            id: '/_documents/verlaufsdokumentation',path: '/verlaufsdokumentation',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditDocumentsUnterschriftsdokumenteRoute = AppPatientenIdEditDocumentsUnterschriftsdokumenteRouteImport.update({
            id: '/_documents/unterschriftsdokumente',path: '/unterschriftsdokumente',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditDocumentsStammblattRoute = AppPatientenIdEditDocumentsStammblattRouteImport.update({
            id: '/_documents/stammblatt',path: '/stammblatt',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditDocumentsBiaMessungRoute = AppPatientenIdEditDocumentsBiaMessungRouteImport.update({
            id: '/_documents/bia-messung',path: '/bia-messung',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditDocumentsBedarfsermittlungenRoute = AppPatientenIdEditDocumentsBedarfsermittlungenRouteImport.update({
            id: '/_documents/bedarfsermittlungen',path: '/bedarfsermittlungen',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditDoctorPraxenRoute = AppPatientenIdEditDoctorPraxenRouteImport.update({
            id: '/_doctor/praxen',path: '/praxen',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditCostCarrierKostentraegerRoute = AppPatientenIdEditCostCarrierKostentraegerRouteImport.update({
            id: '/_costCarrier/kostentraeger',path: '/kostentraeger',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditCooperationPartnerKooperationspartnerRoute = AppPatientenIdEditCooperationPartnerKooperationspartnerRouteImport.update({
            id: '/_cooperationPartner/kooperationspartner',path: '/kooperationspartner',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditClinicKlinikenRoute = AppPatientenIdEditClinicKlinikenRouteImport.update({
            id: '/_clinic/kliniken',path: '/kliniken',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditCareServicePflegediensteRoute = AppPatientenIdEditCareServicePflegediensteRouteImport.update({
            id: '/_careService/pflegedienste',path: '/pflegedienste',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditApplicantAnmelderRoute = AppPatientenIdEditApplicantAnmelderRouteImport.update({
            id: '/_applicant/anmelder',path: '/anmelder',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditZustandigkeitIndexRoute = AppPatientenIdEditZustandigkeitIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPatientenIdEditZustandigkeitRoute
          })
const AppPatientenIdEditZustandigkeitVersorgungsmanagerRoute = AppPatientenIdEditZustandigkeitVersorgungsmanagerRouteImport.update({
            id: '/versorgungsmanager',path: '/versorgungsmanager',getParentRoute: () => AppPatientenIdEditZustandigkeitRoute
          })
const AppPatientenIdEditZustandigkeitAdTeamRoute = AppPatientenIdEditZustandigkeitAdTeamRouteImport.update({
            id: '/ad-team',path: '/ad-team',getParentRoute: () => AppPatientenIdEditZustandigkeitRoute
          })
const AppPatientenIdEditStammdatenIndexRoute = AppPatientenIdEditStammdatenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPatientenIdEditStammdatenRoute
          })
const AppPatientenIdEditStammdatenRechnungsadressenRoute = AppPatientenIdEditStammdatenRechnungsadressenRouteImport.update({
            id: '/rechnungsadressen',path: '/rechnungsadressen',getParentRoute: () => AppPatientenIdEditStammdatenRoute
          })
const AppPatientenIdEditStammdatenLieferadressenRoute = AppPatientenIdEditStammdatenLieferadressenRouteImport.update({
            id: '/lieferadressen',path: '/lieferadressen',getParentRoute: () => AppPatientenIdEditStammdatenRoute
          })
const AppPatientenIdEditStammdatenAngehoerigeRoute = AppPatientenIdEditStammdatenAngehoerigeRouteImport.update({
            id: '/angehoerige',path: '/angehoerige',getParentRoute: () => AppPatientenIdEditStammdatenRoute
          })
const AppPatientenIdEditAnamneseIndexRoute = AppPatientenIdEditAnamneseIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPatientenIdEditAnamneseRoute
          })
const AppPatientenIdEditAnamneseZugangRoute = AppPatientenIdEditAnamneseZugangRouteImport.update({
            id: '/zugang',path: '/zugang',getParentRoute: () => AppPatientenIdEditAnamneseRoute
          })
const AppPatientenIdEditAnamnesePflegegradRoute = AppPatientenIdEditAnamnesePflegegradRouteImport.update({
            id: '/pflegegrad',path: '/pflegegrad',getParentRoute: () => AppPatientenIdEditAnamneseRoute
          })
const AppPatientenIdEditAnamneseMobilitaetRoute = AppPatientenIdEditAnamneseMobilitaetRouteImport.update({
            id: '/mobilitaet',path: '/mobilitaet',getParentRoute: () => AppPatientenIdEditAnamneseRoute
          })
const AppPatientenIdEditAnamneseKoerpergroesseRoute = AppPatientenIdEditAnamneseKoerpergroesseRouteImport.update({
            id: '/koerpergroesse',path: '/koerpergroesse',getParentRoute: () => AppPatientenIdEditAnamneseRoute
          })
const AppPatientenIdEditAnamneseGewichtRoute = AppPatientenIdEditAnamneseGewichtRouteImport.update({
            id: '/gewicht',path: '/gewicht',getParentRoute: () => AppPatientenIdEditAnamneseRoute
          })
const AppPatientenIdEditAnamneseDiagnoseRoute = AppPatientenIdEditAnamneseDiagnoseRouteImport.update({
            id: '/diagnose',path: '/diagnose',getParentRoute: () => AppPatientenIdEditAnamneseRoute
          })
const AppPatientenIdEditDocumentsFormsVerlaufsdokumentationRouteRoute = AppPatientenIdEditDocumentsFormsVerlaufsdokumentationRouteRouteImport.update({
            id: '/_documents/_forms/verlaufsdokumentation',path: '/verlaufsdokumentation',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditDocumentsFormsStammblattRouteRoute = AppPatientenIdEditDocumentsFormsStammblattRouteRouteImport.update({
            id: '/_documents/_forms/stammblatt',path: '/stammblatt',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditDocumentsFormsBiaMessungRouteRoute = AppPatientenIdEditDocumentsFormsBiaMessungRouteRouteImport.update({
            id: '/_documents/_forms/bia-messung',path: '/bia-messung',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditDocumentsFormsBedarfsermittlungRouteRoute = AppPatientenIdEditDocumentsFormsBedarfsermittlungRouteRouteImport.update({
            id: '/_documents/_forms/bedarfsermittlung',path: '/bedarfsermittlung',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditDocumentsFormsUnterschriftdokumenteRouteRoute = AppPatientenIdEditDocumentsFormsUnterschriftdokumenteRouteRouteImport.update({
            id: '/_documents/_forms/_unterschriftdokumente',getParentRoute: () => AppPatientenIdEditRouteRoute
          })
const AppPatientenIdEditTherapyTherapienIndexRoute = AppPatientenIdEditTherapyTherapienIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPatientenIdEditTherapyTherapienRoute
          })
const AppPatientenIdEditTherapyTherapienRelationRoute = AppPatientenIdEditTherapyTherapienRelationRouteImport.update({
            id: '/$relation',path: '/$relation',getParentRoute: () => AppPatientenIdEditTherapyTherapienRoute
          })
const AppPatientenIdEditResidencesAufenthaltsorteIndexRoute = AppPatientenIdEditResidencesAufenthaltsorteIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPatientenIdEditResidencesAufenthaltsorteRoute
          })
const AppPatientenIdEditResidencesAufenthaltsorteRelationRoute = AppPatientenIdEditResidencesAufenthaltsorteRelationRouteImport.update({
            id: '/$relation',path: '/$relation',getParentRoute: () => AppPatientenIdEditResidencesAufenthaltsorteRoute
          })
const AppPatientenIdEditPharmacyApothekenIndexRoute = AppPatientenIdEditPharmacyApothekenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPatientenIdEditPharmacyApothekenRoute
          })
const AppPatientenIdEditPharmacyApothekenRelationRoute = AppPatientenIdEditPharmacyApothekenRelationRouteImport.update({
            id: '/$relation',path: '/$relation',getParentRoute: () => AppPatientenIdEditPharmacyApothekenRoute
          })
const AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerIndexRoute = AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerRoute
          })
const AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerRelationRoute = AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerRelationRouteImport.update({
            id: '/$relation',path: '/$relation',getParentRoute: () => AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerRoute
          })
const AppPatientenIdEditDocumentsUnterschriftsdokumenteIndexRoute = AppPatientenIdEditDocumentsUnterschriftsdokumenteIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPatientenIdEditDocumentsUnterschriftsdokumenteRoute
          })
const AppPatientenIdEditDocumentsUnterschriftsdokumenteVersorgungsauftragRoute = AppPatientenIdEditDocumentsUnterschriftsdokumenteVersorgungsauftragRouteImport.update({
            id: '/versorgungsauftrag',path: '/versorgungsauftrag',getParentRoute: () => AppPatientenIdEditDocumentsUnterschriftsdokumenteRoute
          })
const AppPatientenIdEditDocumentsUnterschriftsdokumentePatienteninformationenRoute = AppPatientenIdEditDocumentsUnterschriftsdokumentePatienteninformationenRouteImport.update({
            id: '/patienteninformationen',path: '/patienteninformationen',getParentRoute: () => AppPatientenIdEditDocumentsUnterschriftsdokumenteRoute
          })
const AppPatientenIdEditDocumentsUnterschriftsdokumenteEinwilligungSchweigepflichtRoute = AppPatientenIdEditDocumentsUnterschriftsdokumenteEinwilligungSchweigepflichtRouteImport.update({
            id: '/einwilligung-schweigepflicht',path: '/einwilligung-schweigepflicht',getParentRoute: () => AppPatientenIdEditDocumentsUnterschriftsdokumenteRoute
          })
const AppPatientenIdEditDocumentsBedarfsermittlungenIndexRoute = AppPatientenIdEditDocumentsBedarfsermittlungenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPatientenIdEditDocumentsBedarfsermittlungenRoute
          })
const AppPatientenIdEditDocumentsBedarfsermittlungenTherapyRoute = AppPatientenIdEditDocumentsBedarfsermittlungenTherapyRouteImport.update({
            id: '/$therapy',path: '/$therapy',getParentRoute: () => AppPatientenIdEditDocumentsBedarfsermittlungenRoute
          })
const AppPatientenIdEditDoctorPraxenIndexRoute = AppPatientenIdEditDoctorPraxenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPatientenIdEditDoctorPraxenRoute
          })
const AppPatientenIdEditDoctorPraxenRelationRoute = AppPatientenIdEditDoctorPraxenRelationRouteImport.update({
            id: '/$relation',path: '/$relation',getParentRoute: () => AppPatientenIdEditDoctorPraxenRoute
          })
const AppPatientenIdEditCostCarrierKostentraegerIndexRoute = AppPatientenIdEditCostCarrierKostentraegerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPatientenIdEditCostCarrierKostentraegerRoute
          })
const AppPatientenIdEditCostCarrierKostentraegerRelationRoute = AppPatientenIdEditCostCarrierKostentraegerRelationRouteImport.update({
            id: '/$relation',path: '/$relation',getParentRoute: () => AppPatientenIdEditCostCarrierKostentraegerRoute
          })
const AppPatientenIdEditCooperationPartnerKooperationspartnerIndexRoute = AppPatientenIdEditCooperationPartnerKooperationspartnerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPatientenIdEditCooperationPartnerKooperationspartnerRoute
          })
const AppPatientenIdEditCooperationPartnerKooperationspartnerRelationRoute = AppPatientenIdEditCooperationPartnerKooperationspartnerRelationRouteImport.update({
            id: '/$relation',path: '/$relation',getParentRoute: () => AppPatientenIdEditCooperationPartnerKooperationspartnerRoute
          })
const AppPatientenIdEditClinicKlinikenIndexRoute = AppPatientenIdEditClinicKlinikenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPatientenIdEditClinicKlinikenRoute
          })
const AppPatientenIdEditClinicKlinikenRelationRoute = AppPatientenIdEditClinicKlinikenRelationRouteImport.update({
            id: '/$relation',path: '/$relation',getParentRoute: () => AppPatientenIdEditClinicKlinikenRoute
          })
const AppPatientenIdEditCareServicePflegediensteIndexRoute = AppPatientenIdEditCareServicePflegediensteIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPatientenIdEditCareServicePflegediensteRoute
          })
const AppPatientenIdEditCareServicePflegediensteRelationRoute = AppPatientenIdEditCareServicePflegediensteRelationRouteImport.update({
            id: '/$relation',path: '/$relation',getParentRoute: () => AppPatientenIdEditCareServicePflegediensteRoute
          })
const AppPatientenIdEditApplicantAnmelderIndexRoute = AppPatientenIdEditApplicantAnmelderIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPatientenIdEditApplicantAnmelderRoute
          })
const AppPatientenIdEditApplicantAnmelderRelationRoute = AppPatientenIdEditApplicantAnmelderRelationRouteImport.update({
            id: '/$relation',path: '/$relation',getParentRoute: () => AppPatientenIdEditApplicantAnmelderRoute
          })
const AppPatientenIdEditDocumentsFormsStammblattNewRoute = AppPatientenIdEditDocumentsFormsStammblattNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AppPatientenIdEditDocumentsFormsStammblattRouteRoute
          })
const AppPatientenIdEditDocumentsFormsBedarfsermittlungNewRoute = AppPatientenIdEditDocumentsFormsBedarfsermittlungNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AppPatientenIdEditDocumentsFormsBedarfsermittlungRouteRoute
          })
const AppPatientenIdEditDocumentsFormsBedarfsermittlungFormRoute = AppPatientenIdEditDocumentsFormsBedarfsermittlungFormRouteImport.update({
            id: '/$form',path: '/$form',getParentRoute: () => AppPatientenIdEditDocumentsFormsBedarfsermittlungRouteRoute
          })
const AppPatientenIdEditDocumentsFormsVerlaufsdokumentationFormIndexRoute = AppPatientenIdEditDocumentsFormsVerlaufsdokumentationFormIndexRouteImport.update({
            id: '/$form/',path: '/$form/',getParentRoute: () => AppPatientenIdEditDocumentsFormsVerlaufsdokumentationRouteRoute
          })
const AppPatientenIdEditDocumentsFormsStammblattFormIndexRoute = AppPatientenIdEditDocumentsFormsStammblattFormIndexRouteImport.update({
            id: '/$form/',path: '/$form/',getParentRoute: () => AppPatientenIdEditDocumentsFormsStammblattRouteRoute
          })
const AppPatientenIdEditDocumentsFormsBiaMessungFormIndexRoute = AppPatientenIdEditDocumentsFormsBiaMessungFormIndexRouteImport.update({
            id: '/$form/',path: '/$form/',getParentRoute: () => AppPatientenIdEditDocumentsFormsBiaMessungRouteRoute
          })
const AppPatientenIdEditDocumentsFormsBedarfsermittlungFormIndexRoute = AppPatientenIdEditDocumentsFormsBedarfsermittlungFormIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPatientenIdEditDocumentsFormsBedarfsermittlungFormRoute
          })
const AppPatientenIdEditDocumentsFormsBedarfsermittlungFormArticlesRoute = AppPatientenIdEditDocumentsFormsBedarfsermittlungFormArticlesRouteImport.update({
            id: '/articles',path: '/articles',getParentRoute: () => AppPatientenIdEditDocumentsFormsBedarfsermittlungFormRoute
          })
const AppPatientenIdEditDocumentsFormsUnterschriftdokumenteVersorgungsauftragFormIndexRoute = AppPatientenIdEditDocumentsFormsUnterschriftdokumenteVersorgungsauftragFormIndexRouteImport.update({
            id: '/versorgungsauftrag/$form/',path: '/versorgungsauftrag/$form/',getParentRoute: () => AppPatientenIdEditDocumentsFormsUnterschriftdokumenteRouteRoute
          })
const AppPatientenIdEditDocumentsFormsUnterschriftdokumentePatientenInformationFormIndexRoute = AppPatientenIdEditDocumentsFormsUnterschriftdokumentePatientenInformationFormIndexRouteImport.update({
            id: '/patienten-information/$form/',path: '/patienten-information/$form/',getParentRoute: () => AppPatientenIdEditDocumentsFormsUnterschriftdokumenteRouteRoute
          })
const AppPatientenIdEditDocumentsFormsUnterschriftdokumenteEinwilligungSchweigepflichtFormIndexRoute = AppPatientenIdEditDocumentsFormsUnterschriftdokumenteEinwilligungSchweigepflichtFormIndexRouteImport.update({
            id: '/einwilligung-schweigepflicht/$form/',path: '/einwilligung-schweigepflicht/$form/',getParentRoute: () => AppPatientenIdEditDocumentsFormsUnterschriftdokumenteRouteRoute
          })





const AppDashboardsRouteRouteChildren = {
  AppDashboardsBiaMeasurementsRoute: AppDashboardsBiaMeasurementsRoute,AppDashboardsMasterDataSheetsRoute: AppDashboardsMasterDataSheetsRoute,AppDashboardsMissingDataRoute: AppDashboardsMissingDataRoute,AppDashboardsMyPatientsRoute: AppDashboardsMyPatientsRoute,AppDashboardsNotificationsRoute: AppDashboardsNotificationsRoute,AppDashboardsOrdersRoute: AppDashboardsOrdersRoute,AppDashboardsOrdersStockRoute: AppDashboardsOrdersStockRoute,AppDashboardsProgressReportsRoute: AppDashboardsProgressReportsRoute,AppDashboardsRegisteredPatientsRoute: AppDashboardsRegisteredPatientsRoute,AppDashboardsSignedRoute: AppDashboardsSignedRoute
}

const AppDashboardsRouteRouteWithChildren = AppDashboardsRouteRoute._addFileChildren(AppDashboardsRouteRouteChildren)




const AppPatientenIdEditAnamneseRouteChildren = {
  AppPatientenIdEditAnamneseDiagnoseRoute: AppPatientenIdEditAnamneseDiagnoseRoute,AppPatientenIdEditAnamneseGewichtRoute: AppPatientenIdEditAnamneseGewichtRoute,AppPatientenIdEditAnamneseKoerpergroesseRoute: AppPatientenIdEditAnamneseKoerpergroesseRoute,AppPatientenIdEditAnamneseMobilitaetRoute: AppPatientenIdEditAnamneseMobilitaetRoute,AppPatientenIdEditAnamnesePflegegradRoute: AppPatientenIdEditAnamnesePflegegradRoute,AppPatientenIdEditAnamneseZugangRoute: AppPatientenIdEditAnamneseZugangRoute,AppPatientenIdEditAnamneseIndexRoute: AppPatientenIdEditAnamneseIndexRoute
}

const AppPatientenIdEditAnamneseRouteWithChildren = AppPatientenIdEditAnamneseRoute._addFileChildren(AppPatientenIdEditAnamneseRouteChildren)




const AppPatientenIdEditStammdatenRouteChildren = {
  AppPatientenIdEditStammdatenAngehoerigeRoute: AppPatientenIdEditStammdatenAngehoerigeRoute,AppPatientenIdEditStammdatenLieferadressenRoute: AppPatientenIdEditStammdatenLieferadressenRoute,AppPatientenIdEditStammdatenRechnungsadressenRoute: AppPatientenIdEditStammdatenRechnungsadressenRoute,AppPatientenIdEditStammdatenIndexRoute: AppPatientenIdEditStammdatenIndexRoute
}

const AppPatientenIdEditStammdatenRouteWithChildren = AppPatientenIdEditStammdatenRoute._addFileChildren(AppPatientenIdEditStammdatenRouteChildren)




const AppPatientenIdEditZustandigkeitRouteChildren = {
  AppPatientenIdEditZustandigkeitAdTeamRoute: AppPatientenIdEditZustandigkeitAdTeamRoute,AppPatientenIdEditZustandigkeitVersorgungsmanagerRoute: AppPatientenIdEditZustandigkeitVersorgungsmanagerRoute,AppPatientenIdEditZustandigkeitIndexRoute: AppPatientenIdEditZustandigkeitIndexRoute
}

const AppPatientenIdEditZustandigkeitRouteWithChildren = AppPatientenIdEditZustandigkeitRoute._addFileChildren(AppPatientenIdEditZustandigkeitRouteChildren)




const AppPatientenIdEditApplicantAnmelderRouteChildren = {
  AppPatientenIdEditApplicantAnmelderRelationRoute: AppPatientenIdEditApplicantAnmelderRelationRoute,AppPatientenIdEditApplicantAnmelderIndexRoute: AppPatientenIdEditApplicantAnmelderIndexRoute
}

const AppPatientenIdEditApplicantAnmelderRouteWithChildren = AppPatientenIdEditApplicantAnmelderRoute._addFileChildren(AppPatientenIdEditApplicantAnmelderRouteChildren)




const AppPatientenIdEditCareServicePflegediensteRouteChildren = {
  AppPatientenIdEditCareServicePflegediensteRelationRoute: AppPatientenIdEditCareServicePflegediensteRelationRoute,AppPatientenIdEditCareServicePflegediensteIndexRoute: AppPatientenIdEditCareServicePflegediensteIndexRoute
}

const AppPatientenIdEditCareServicePflegediensteRouteWithChildren = AppPatientenIdEditCareServicePflegediensteRoute._addFileChildren(AppPatientenIdEditCareServicePflegediensteRouteChildren)




const AppPatientenIdEditClinicKlinikenRouteChildren = {
  AppPatientenIdEditClinicKlinikenRelationRoute: AppPatientenIdEditClinicKlinikenRelationRoute,AppPatientenIdEditClinicKlinikenIndexRoute: AppPatientenIdEditClinicKlinikenIndexRoute
}

const AppPatientenIdEditClinicKlinikenRouteWithChildren = AppPatientenIdEditClinicKlinikenRoute._addFileChildren(AppPatientenIdEditClinicKlinikenRouteChildren)




const AppPatientenIdEditCooperationPartnerKooperationspartnerRouteChildren = {
  AppPatientenIdEditCooperationPartnerKooperationspartnerRelationRoute: AppPatientenIdEditCooperationPartnerKooperationspartnerRelationRoute,AppPatientenIdEditCooperationPartnerKooperationspartnerIndexRoute: AppPatientenIdEditCooperationPartnerKooperationspartnerIndexRoute
}

const AppPatientenIdEditCooperationPartnerKooperationspartnerRouteWithChildren = AppPatientenIdEditCooperationPartnerKooperationspartnerRoute._addFileChildren(AppPatientenIdEditCooperationPartnerKooperationspartnerRouteChildren)




const AppPatientenIdEditCostCarrierKostentraegerRouteChildren = {
  AppPatientenIdEditCostCarrierKostentraegerRelationRoute: AppPatientenIdEditCostCarrierKostentraegerRelationRoute,AppPatientenIdEditCostCarrierKostentraegerIndexRoute: AppPatientenIdEditCostCarrierKostentraegerIndexRoute
}

const AppPatientenIdEditCostCarrierKostentraegerRouteWithChildren = AppPatientenIdEditCostCarrierKostentraegerRoute._addFileChildren(AppPatientenIdEditCostCarrierKostentraegerRouteChildren)




const AppPatientenIdEditDoctorPraxenRouteChildren = {
  AppPatientenIdEditDoctorPraxenRelationRoute: AppPatientenIdEditDoctorPraxenRelationRoute,AppPatientenIdEditDoctorPraxenIndexRoute: AppPatientenIdEditDoctorPraxenIndexRoute
}

const AppPatientenIdEditDoctorPraxenRouteWithChildren = AppPatientenIdEditDoctorPraxenRoute._addFileChildren(AppPatientenIdEditDoctorPraxenRouteChildren)




const AppPatientenIdEditDocumentsBedarfsermittlungenRouteChildren = {
  AppPatientenIdEditDocumentsBedarfsermittlungenTherapyRoute: AppPatientenIdEditDocumentsBedarfsermittlungenTherapyRoute,AppPatientenIdEditDocumentsBedarfsermittlungenIndexRoute: AppPatientenIdEditDocumentsBedarfsermittlungenIndexRoute
}

const AppPatientenIdEditDocumentsBedarfsermittlungenRouteWithChildren = AppPatientenIdEditDocumentsBedarfsermittlungenRoute._addFileChildren(AppPatientenIdEditDocumentsBedarfsermittlungenRouteChildren)




const AppPatientenIdEditDocumentsUnterschriftsdokumenteRouteChildren = {
  AppPatientenIdEditDocumentsUnterschriftsdokumenteEinwilligungSchweigepflichtRoute: AppPatientenIdEditDocumentsUnterschriftsdokumenteEinwilligungSchweigepflichtRoute,AppPatientenIdEditDocumentsUnterschriftsdokumentePatienteninformationenRoute: AppPatientenIdEditDocumentsUnterschriftsdokumentePatienteninformationenRoute,AppPatientenIdEditDocumentsUnterschriftsdokumenteVersorgungsauftragRoute: AppPatientenIdEditDocumentsUnterschriftsdokumenteVersorgungsauftragRoute,AppPatientenIdEditDocumentsUnterschriftsdokumenteIndexRoute: AppPatientenIdEditDocumentsUnterschriftsdokumenteIndexRoute
}

const AppPatientenIdEditDocumentsUnterschriftsdokumenteRouteWithChildren = AppPatientenIdEditDocumentsUnterschriftsdokumenteRoute._addFileChildren(AppPatientenIdEditDocumentsUnterschriftsdokumenteRouteChildren)




const AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerRouteChildren = {
  AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerRelationRoute: AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerRelationRoute,AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerIndexRoute: AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerIndexRoute
}

const AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerRouteWithChildren = AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerRoute._addFileChildren(AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerRouteChildren)




const AppPatientenIdEditPharmacyApothekenRouteChildren = {
  AppPatientenIdEditPharmacyApothekenRelationRoute: AppPatientenIdEditPharmacyApothekenRelationRoute,AppPatientenIdEditPharmacyApothekenIndexRoute: AppPatientenIdEditPharmacyApothekenIndexRoute
}

const AppPatientenIdEditPharmacyApothekenRouteWithChildren = AppPatientenIdEditPharmacyApothekenRoute._addFileChildren(AppPatientenIdEditPharmacyApothekenRouteChildren)




const AppPatientenIdEditResidencesAufenthaltsorteRouteChildren = {
  AppPatientenIdEditResidencesAufenthaltsorteRelationRoute: AppPatientenIdEditResidencesAufenthaltsorteRelationRoute,AppPatientenIdEditResidencesAufenthaltsorteIndexRoute: AppPatientenIdEditResidencesAufenthaltsorteIndexRoute
}

const AppPatientenIdEditResidencesAufenthaltsorteRouteWithChildren = AppPatientenIdEditResidencesAufenthaltsorteRoute._addFileChildren(AppPatientenIdEditResidencesAufenthaltsorteRouteChildren)




const AppPatientenIdEditTherapyTherapienRouteChildren = {
  AppPatientenIdEditTherapyTherapienRelationRoute: AppPatientenIdEditTherapyTherapienRelationRoute,AppPatientenIdEditTherapyTherapienIndexRoute: AppPatientenIdEditTherapyTherapienIndexRoute
}

const AppPatientenIdEditTherapyTherapienRouteWithChildren = AppPatientenIdEditTherapyTherapienRoute._addFileChildren(AppPatientenIdEditTherapyTherapienRouteChildren)




const AppPatientenIdEditDocumentsFormsUnterschriftdokumenteRouteRouteChildren = {
  AppPatientenIdEditDocumentsFormsUnterschriftdokumenteEinwilligungSchweigepflichtFormIndexRoute: AppPatientenIdEditDocumentsFormsUnterschriftdokumenteEinwilligungSchweigepflichtFormIndexRoute,AppPatientenIdEditDocumentsFormsUnterschriftdokumentePatientenInformationFormIndexRoute: AppPatientenIdEditDocumentsFormsUnterschriftdokumentePatientenInformationFormIndexRoute,AppPatientenIdEditDocumentsFormsUnterschriftdokumenteVersorgungsauftragFormIndexRoute: AppPatientenIdEditDocumentsFormsUnterschriftdokumenteVersorgungsauftragFormIndexRoute
}

const AppPatientenIdEditDocumentsFormsUnterschriftdokumenteRouteRouteWithChildren = AppPatientenIdEditDocumentsFormsUnterschriftdokumenteRouteRoute._addFileChildren(AppPatientenIdEditDocumentsFormsUnterschriftdokumenteRouteRouteChildren)




const AppPatientenIdEditDocumentsFormsBedarfsermittlungFormRouteChildren = {
  AppPatientenIdEditDocumentsFormsBedarfsermittlungFormArticlesRoute: AppPatientenIdEditDocumentsFormsBedarfsermittlungFormArticlesRoute,AppPatientenIdEditDocumentsFormsBedarfsermittlungFormIndexRoute: AppPatientenIdEditDocumentsFormsBedarfsermittlungFormIndexRoute
}

const AppPatientenIdEditDocumentsFormsBedarfsermittlungFormRouteWithChildren = AppPatientenIdEditDocumentsFormsBedarfsermittlungFormRoute._addFileChildren(AppPatientenIdEditDocumentsFormsBedarfsermittlungFormRouteChildren)



const AppPatientenIdEditDocumentsFormsBedarfsermittlungRouteRouteChildren = {
  AppPatientenIdEditDocumentsFormsBedarfsermittlungFormRoute: AppPatientenIdEditDocumentsFormsBedarfsermittlungFormRouteWithChildren,AppPatientenIdEditDocumentsFormsBedarfsermittlungNewRoute: AppPatientenIdEditDocumentsFormsBedarfsermittlungNewRoute
}

const AppPatientenIdEditDocumentsFormsBedarfsermittlungRouteRouteWithChildren = AppPatientenIdEditDocumentsFormsBedarfsermittlungRouteRoute._addFileChildren(AppPatientenIdEditDocumentsFormsBedarfsermittlungRouteRouteChildren)




const AppPatientenIdEditDocumentsFormsBiaMessungRouteRouteChildren = {
  AppPatientenIdEditDocumentsFormsBiaMessungFormIndexRoute: AppPatientenIdEditDocumentsFormsBiaMessungFormIndexRoute
}

const AppPatientenIdEditDocumentsFormsBiaMessungRouteRouteWithChildren = AppPatientenIdEditDocumentsFormsBiaMessungRouteRoute._addFileChildren(AppPatientenIdEditDocumentsFormsBiaMessungRouteRouteChildren)




const AppPatientenIdEditDocumentsFormsStammblattRouteRouteChildren = {
  AppPatientenIdEditDocumentsFormsStammblattNewRoute: AppPatientenIdEditDocumentsFormsStammblattNewRoute,AppPatientenIdEditDocumentsFormsStammblattFormIndexRoute: AppPatientenIdEditDocumentsFormsStammblattFormIndexRoute
}

const AppPatientenIdEditDocumentsFormsStammblattRouteRouteWithChildren = AppPatientenIdEditDocumentsFormsStammblattRouteRoute._addFileChildren(AppPatientenIdEditDocumentsFormsStammblattRouteRouteChildren)




const AppPatientenIdEditDocumentsFormsVerlaufsdokumentationRouteRouteChildren = {
  AppPatientenIdEditDocumentsFormsVerlaufsdokumentationFormIndexRoute: AppPatientenIdEditDocumentsFormsVerlaufsdokumentationFormIndexRoute
}

const AppPatientenIdEditDocumentsFormsVerlaufsdokumentationRouteRouteWithChildren = AppPatientenIdEditDocumentsFormsVerlaufsdokumentationRouteRoute._addFileChildren(AppPatientenIdEditDocumentsFormsVerlaufsdokumentationRouteRouteChildren)



const AppPatientenIdEditRouteRouteChildren = {
  AppPatientenIdEditAnamneseRoute: AppPatientenIdEditAnamneseRouteWithChildren,AppPatientenIdEditStammdatenRoute: AppPatientenIdEditStammdatenRouteWithChildren,AppPatientenIdEditZustandigkeitRoute: AppPatientenIdEditZustandigkeitRouteWithChildren,AppPatientenIdEditApplicantAnmelderRoute: AppPatientenIdEditApplicantAnmelderRouteWithChildren,AppPatientenIdEditCareServicePflegediensteRoute: AppPatientenIdEditCareServicePflegediensteRouteWithChildren,AppPatientenIdEditClinicKlinikenRoute: AppPatientenIdEditClinicKlinikenRouteWithChildren,AppPatientenIdEditCooperationPartnerKooperationspartnerRoute: AppPatientenIdEditCooperationPartnerKooperationspartnerRouteWithChildren,AppPatientenIdEditCostCarrierKostentraegerRoute: AppPatientenIdEditCostCarrierKostentraegerRouteWithChildren,AppPatientenIdEditDoctorPraxenRoute: AppPatientenIdEditDoctorPraxenRouteWithChildren,AppPatientenIdEditDocumentsBedarfsermittlungenRoute: AppPatientenIdEditDocumentsBedarfsermittlungenRouteWithChildren,AppPatientenIdEditDocumentsBiaMessungRoute: AppPatientenIdEditDocumentsBiaMessungRoute,AppPatientenIdEditDocumentsStammblattRoute: AppPatientenIdEditDocumentsStammblattRoute,AppPatientenIdEditDocumentsUnterschriftsdokumenteRoute: AppPatientenIdEditDocumentsUnterschriftsdokumenteRouteWithChildren,AppPatientenIdEditDocumentsVerlaufsdokumentationRoute: AppPatientenIdEditDocumentsVerlaufsdokumentationRoute,AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerRoute: AppPatientenIdEditMedicalTechnologyMedizintechnikversorgerRouteWithChildren,AppPatientenIdEditPharmacyApothekenRoute: AppPatientenIdEditPharmacyApothekenRouteWithChildren,AppPatientenIdEditResidencesAufenthaltsorteRoute: AppPatientenIdEditResidencesAufenthaltsorteRouteWithChildren,AppPatientenIdEditTherapyTherapienRoute: AppPatientenIdEditTherapyTherapienRouteWithChildren,AppPatientenIdEditDocumentsFormsUnterschriftdokumenteRouteRoute: AppPatientenIdEditDocumentsFormsUnterschriftdokumenteRouteRouteWithChildren,AppPatientenIdEditDocumentsFormsBedarfsermittlungRouteRoute: AppPatientenIdEditDocumentsFormsBedarfsermittlungRouteRouteWithChildren,AppPatientenIdEditDocumentsFormsBiaMessungRouteRoute: AppPatientenIdEditDocumentsFormsBiaMessungRouteRouteWithChildren,AppPatientenIdEditDocumentsFormsStammblattRouteRoute: AppPatientenIdEditDocumentsFormsStammblattRouteRouteWithChildren,AppPatientenIdEditDocumentsFormsVerlaufsdokumentationRouteRoute: AppPatientenIdEditDocumentsFormsVerlaufsdokumentationRouteRouteWithChildren
}

const AppPatientenIdEditRouteRouteWithChildren = AppPatientenIdEditRouteRoute._addFileChildren(AppPatientenIdEditRouteRouteChildren)



const AppPatientenIdRouteRouteChildren = {
  AppPatientenIdEditRouteRoute: AppPatientenIdEditRouteRouteWithChildren,AppPatientenIdOverviewIndexRoute: AppPatientenIdOverviewIndexRoute
}

const AppPatientenIdRouteRouteWithChildren = AppPatientenIdRouteRoute._addFileChildren(AppPatientenIdRouteRouteChildren)




const AppAdteamIdRouteChildren = {
  AppAdteamIdIndexRoute: AppAdteamIdIndexRoute
}

const AppAdteamIdRouteWithChildren = AppAdteamIdRoute._addFileChildren(AppAdteamIdRouteChildren)




const AppApothekenIdRouteChildren = {
  AppApothekenIdContactPersonsRoute: AppApothekenIdContactPersonsRoute,AppApothekenIdIndexRoute: AppApothekenIdIndexRoute
}

const AppApothekenIdRouteWithChildren = AppApothekenIdRoute._addFileChildren(AppApothekenIdRouteChildren)




const AppArtikelIdRouteChildren = {
  AppArtikelIdRelationsRoute: AppArtikelIdRelationsRoute,AppArtikelIdIndexRoute: AppArtikelIdIndexRoute
}

const AppArtikelIdRouteWithChildren = AppArtikelIdRoute._addFileChildren(AppArtikelIdRouteChildren)




const AppHospizeIdRouteChildren = {
  AppHospizeIdContactPersonsRoute: AppHospizeIdContactPersonsRoute,AppHospizeIdIndexRoute: AppHospizeIdIndexRoute
}

const AppHospizeIdRouteWithChildren = AppHospizeIdRoute._addFileChildren(AppHospizeIdRouteChildren)




const AppKlinikenIdRouteChildren = {
  AppKlinikenIdContactPersonsRoute: AppKlinikenIdContactPersonsRoute,AppKlinikenIdStationsRoute: AppKlinikenIdStationsRoute,AppKlinikenIdIndexRoute: AppKlinikenIdIndexRoute
}

const AppKlinikenIdRouteWithChildren = AppKlinikenIdRoute._addFileChildren(AppKlinikenIdRouteChildren)




const AppKostentragerIdRouteChildren = {
  AppKostentragerIdContactPersonsRoute: AppKostentragerIdContactPersonsRoute,AppKostentragerIdIkNumbersRoute: AppKostentragerIdIkNumbersRoute,AppKostentragerIdIndexRoute: AppKostentragerIdIndexRoute
}

const AppKostentragerIdRouteWithChildren = AppKostentragerIdRoute._addFileChildren(AppKostentragerIdRouteChildren)




const AppMedizintechnikIdRouteChildren = {
  AppMedizintechnikIdContactPersonsRoute: AppMedizintechnikIdContactPersonsRoute,AppMedizintechnikIdIndexRoute: AppMedizintechnikIdIndexRoute
}

const AppMedizintechnikIdRouteWithChildren = AppMedizintechnikIdRoute._addFileChildren(AppMedizintechnikIdRouteChildren)




const AppMitarbeiterIdRouteChildren = {
  AppMitarbeiterIdIndexRoute: AppMitarbeiterIdIndexRoute
}

const AppMitarbeiterIdRouteWithChildren = AppMitarbeiterIdRoute._addFileChildren(AppMitarbeiterIdRouteChildren)




const AppPflegediensteIdRouteChildren = {
  AppPflegediensteIdContactPersonsRoute: AppPflegediensteIdContactPersonsRoute,AppPflegediensteIdIndexRoute: AppPflegediensteIdIndexRoute
}

const AppPflegediensteIdRouteWithChildren = AppPflegediensteIdRoute._addFileChildren(AppPflegediensteIdRouteChildren)




const AppPflegeheimeIdRouteChildren = {
  AppPflegeheimeIdContactPersonsRoute: AppPflegeheimeIdContactPersonsRoute,AppPflegeheimeIdIndexRoute: AppPflegeheimeIdIndexRoute
}

const AppPflegeheimeIdRouteWithChildren = AppPflegeheimeIdRoute._addFileChildren(AppPflegeheimeIdRouteChildren)




const AppPraxenIdRouteChildren = {
  AppPraxenIdContactPersonsRoute: AppPraxenIdContactPersonsRoute,AppPraxenIdIndexRoute: AppPraxenIdIndexRoute
}

const AppPraxenIdRouteWithChildren = AppPraxenIdRoute._addFileChildren(AppPraxenIdRouteChildren)




const AppSanitaetshaeuserIdRouteChildren = {
  AppSanitaetshaeuserIdContactPersonsRoute: AppSanitaetshaeuserIdContactPersonsRoute,AppSanitaetshaeuserIdIndexRoute: AppSanitaetshaeuserIdIndexRoute
}

const AppSanitaetshaeuserIdRouteWithChildren = AppSanitaetshaeuserIdRoute._addFileChildren(AppSanitaetshaeuserIdRouteChildren)



const AppRouteChildren = {
  AppDashboardsRouteRoute: AppDashboardsRouteRouteWithChildren,AppIndexRoute: AppIndexRoute,AppPatientenIdRouteRoute: AppPatientenIdRouteRouteWithChildren,AppAdteamIdRoute: AppAdteamIdRouteWithChildren,AppApothekenIdRoute: AppApothekenIdRouteWithChildren,AppArtikelIdRoute: AppArtikelIdRouteWithChildren,AppGotoIdRoute: AppGotoIdRoute,AppHospizeIdRoute: AppHospizeIdRouteWithChildren,AppKlinikenIdRoute: AppKlinikenIdRouteWithChildren,AppKostentragerIdRoute: AppKostentragerIdRouteWithChildren,AppMedizintechnikIdRoute: AppMedizintechnikIdRouteWithChildren,AppMitarbeiterIdRoute: AppMitarbeiterIdRouteWithChildren,AppPflegediensteIdRoute: AppPflegediensteIdRouteWithChildren,AppPflegeheimeIdRoute: AppPflegeheimeIdRouteWithChildren,AppPraxenIdRoute: AppPraxenIdRouteWithChildren,AppSanitaetshaeuserIdRoute: AppSanitaetshaeuserIdRouteWithChildren,AppAdteamIndexRoute: AppAdteamIndexRoute,AppApothekenIndexRoute: AppApothekenIndexRoute,AppArtikelIndexRoute: AppArtikelIndexRoute,AppHospizeIndexRoute: AppHospizeIndexRoute,AppKlinikenIndexRoute: AppKlinikenIndexRoute,AppKostentragerIndexRoute: AppKostentragerIndexRoute,AppMedizintechnikIndexRoute: AppMedizintechnikIndexRoute,AppMitarbeiterIndexRoute: AppMitarbeiterIndexRoute,AppPatientenIndexRoute: AppPatientenIndexRoute,AppPflegediensteIndexRoute: AppPflegediensteIndexRoute,AppPflegeheimeIndexRoute: AppPflegeheimeIndexRoute,AppPraxenIndexRoute: AppPraxenIndexRoute,AppSanitaetshaeuserIndexRoute: AppSanitaetshaeuserIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  AppRoute: AppRouteWithChildren,PdfIdRoute: PdfIdRoute,MaintenanceIndexRoute: MaintenanceIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)